import React, { useState } from "react";
import { FaFilter } from "react-icons/fa";

const SearchBar = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
    verified: "",
    gender: "",
    experience: "",
    rating: "",
  });
  const [showFilters, setShowFilters] = useState(false);

  const handleSearch = () => {
    if (onSearch) {
      onSearch({ searchQuery, ...filters });
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  return (
    <div className="container mx-auto my-4 px-8 py-4 bg-gray-100 rounded-xl shadow-xs">
      {/* Search Bar */}
      <div className="flex items-center gap-4">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
          className="flex-1 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-csyellow"
        />
        <button
          className="flex items-center justify-center bg-csyellow text-white px-4 py-2 rounded-lg hover:bg-csgreendark focus:outline-none focus:ring-2 focus:ring-csyellow"
          onClick={() => setShowFilters(!showFilters)}
        >
          <FaFilter className="mr-2" />
          Filters
        </button>
      </div>

      {/* Filters Dropdown */}
      {showFilters && (
        <div className="mt-4 p-4 bg-white rounded-lg border border-gray-300">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Verified Filter */}
            <div className="flex flex-col">
              <label
                htmlFor="verified"
                className="text-gray-700 font-semibold mb-1"
              >
                Verified
              </label>
              <select
                id="verified"
                name="verified"
                value={filters.verified}
                onChange={handleFilterChange}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-csgreen"
              >
                <option value="">All</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>

            {/* Gender Filter */}
            <div className="flex flex-col">
              <label
                htmlFor="gender"
                className="text-gray-700 font-semibold mb-1"
              >
                Gender
              </label>
              <select
                id="gender"
                name="gender"
                value={filters.gender}
                onChange={handleFilterChange}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-csyellow"
              >
                <option value="">All</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>

            {/* Experience Filter */}
            <div className="flex flex-col">
              <label
                htmlFor="experience"
                className="text-gray-700 font-semibold mb-1"
              >
                Experience
              </label>
              <input
                type="text"
                id="experience"
                name="experience"
                value={filters.experience}
                onChange={handleFilterChange}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-csyellow"
              />
            </div>

            {/* Rating Filter */}
            <div className="flex flex-col">
              <label
                htmlFor="rating"
                className="text-gray-700 font-semibold mb-1"
              >
                Rating
              </label>
              <input
                type="text"
                id="rating"
                name="rating"
                value={filters.rating}
                onChange={handleFilterChange}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-csyellow"
              />
            </div>
          </div>

          {/* Apply Filters Button */}
          <div className="mt-4 text-right">
            <button
              className="bg-csyellow text-white px-6 py-2 rounded-lg hover:bg-csgreendark focus:outline-none focus:ring-2 focus:ring-csyellow"
              onClick={handleSearch}
            >
              Apply Filters & Search
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
